import { render, staticRenderFns } from "./PartnerUsers.vue?vue&type=template&id=d70dc0cc&"
import script from "./PartnerUsers.vue?vue&type=script&lang=ts&"
export * from "./PartnerUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports